module.exports = __webpack_public_path__ + "img/TeleHealth.c5b7e383.svg";